/* @flow */
import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import * as ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../apollo-client';
import {store} from '../store';
import {PhoneCallContainer} from '../ui/phone-call/phone-call-container';

export type PhoneCallParameters = {|
    entityId: string,
    activityId?: string,
    phoneNumber: {
        E164: string,
        numberFormatted: string,
    },
    shouldRecord?: boolean,
    shouldTranscribe?: boolean,
    shouldSummarize?: boolean,
|};

export function call(parameters: PhoneCallParameters) {
    const overlay = document.getElementById('phone-call-overlay');

    // There is already an active overlay lets just bail
    if (!overlay || overlay.childElementCount) {
        logError('Attempted to place call while overlay is open');

        return;
    }

    const phoneCallContainer = (
        <Provider store={store}>
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <PhoneCallContainer
                        {...parameters}
                        onClose={() => {
                            ReactDOM.unmountComponentAtNode(overlay);
                        }}
                    />
                </ReactHooksApolloProvider>
            </ApolloProvider>
        </Provider>
    );
    ReactDOM.render(phoneCallContainer, overlay);
}

function logError(errorMessage) {
    if (typeof window.trackJs !== 'undefined') {
        window.trackJs.track(errorMessage);
    }
}
